import { render, staticRenderFns } from "./access_control.vue?vue&type=template&id=59b93fde&scoped=true&"
import script from "./access_control.js?vue&type=script&lang=js&"
export * from "./access_control.js?vue&type=script&lang=js&"
import style0 from "./access_control.css?vue&type=style&index=0&id=59b93fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b93fde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
